import React from "react"
import {Form} from "antd"
import {RangePicker} from "../../../../ui/RangePicker";
import {useTranslations} from "../hooks/use-translations"

export default function PeriodField() {
  const t = useTranslations()

  return (
    <>
      <Form.Item name="period" label={t("coupons.form.period")}>
        <RangePicker name="period"/>

      </Form.Item>
      <div className="description">
        {t("coupons.form.period.description")}
      </div>
    </>
  );
}